import React from "react";
import { FaqDropdown } from "../../../components/faq-dropdown";
import { Main } from "../../../layouts/main";

import { Container } from "./styles";

const initialState = {
  0: false,
  1: false,
  2: false
};

export const Patient: React.FC = () => {
  const [state, setState] = React.useState({
    0: false,
    1: false,
    2: false,
  });

  return (
    <Main>
      <Container>
        <FaqDropdown
          marginTop={1}
          state={state[0]}
          content={'Como entrego minha guia autorizada?'}
          onClick={() => {
            setState((old) => (old = { ...initialState, 0: !old[0] }));
          }}
        >
          Na nossa página inicial, apresentamos um botão "ENVIAR GUIA", clique e será direcionado ao fomulário de entrega 
          da guia. Lembre-se de identificar corretamente o CIRURGIÃO e Anexar sua Guia Autorizada.
        </FaqDropdown>
        <FaqDropdown
          marginTop={1}
          state={state[1]}
          content={'É seguro utilizar a plataforma cirurgia autorizada?'}
          onClick={() => {
            setState((old) => (old = { ...initialState, 1: !old[1] }));
          }}
        >
          Pode ficar tranquilo(a). Somente terá acesso às suas informações os participantes do fluxo do agendamento do SEU 
          CIRURGIÃO (secretária, fornecedor e hospital designado por ele).<br/>
          Nossa base de dados está em conformidade com a LGPD (Lei Geral de Proteção de dados) e suas informações apenas 
          serão utilizadas para o fim específico do agendamento cirúrgico
        </FaqDropdown>
        <FaqDropdown
          marginTop={1}
          state={state[2]}
          content={'Quais as vantagens do uso da plataforma CirurgiaAutorizada'}
          onClick={() => {
            setState((old) => (old = { ...initialState, 2: !old[2] }));
          }}
        >
          A principal delas é organizar e documentar todo o processo de agendamento cirúrgico.<br/>

          <br style={{marginTop: '2rem'}}/>Especificamente para o paciente:
          <br/>- Segurança
          <br/>- Avisos do andamento do processo de agendamento
          <br/>- Em breve, cupons para descontos específicos
        </FaqDropdown>
      </Container>
    </Main>
  );
};
